import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ size = "md", showTagline = false, dark = false }) {
    const cls = size === "lg" ? "text-5xl" : size === "sm" ? "text-2xl" : "text-3xl";
    const color = dark ? "text-ivory-100" : "text-sage-700";
    return (
        <Link to="/" className="inline-flex flex-col items-center group" data-testid="brand-logo">
            <span className={`font-serif italic ${cls} ${color} leading-none tracking-tight`}>
                L<span className="relative inline-block">
                    o<span className="absolute -top-1 left-1/2 -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-sage-400" />
                </span>
                <span className="relative inline-block">
                    o<span className="absolute -top-1 left-1/2 -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-blush-400" />
                </span>
                mara
            </span>
            {showTagline && (
                <span className="hidden xl:block text-[10px] tracking-[0.3em] uppercase text-sage-600 mt-1 text-center">
                    Joyfully designed from the first crawl
                </span>
            )}
        </Link>
    );
}
